"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function dragSource(isDragging) {
  return (0, _utils.actionCreator)(_types.BROADCAST_DRAG_SOURCE, {
    isDragging: isDragging
  });
}
var _default = exports["default"] = dragSource;